"use client";

import { UserLocationProvider } from "@/context/user-location.context";
import { WorkflowTriggerProvider } from "@/context/workflow-trigger.context";

declare global {
  const GTM: (new () => unknown) | undefined;
  interface Window {
    IntercomGTM: any;
  }
}

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <GTMJSInitiator>
      <UserLocationProvider>
        <WorkflowTriggerProvider>{children}</WorkflowTriggerProvider>
      </UserLocationProvider>
    </GTMJSInitiator>
  );
};

const GTMJSInitiator = ({ children }: { children: React.ReactNode }) => {
  if (typeof GTM !== "undefined" && !window.IntercomGTM) {
    window.IntercomGTM = new GTM();
  }

  return children;
};
